import {Component, OnInit} from '@angular/core';
import {UserConstant, UserStatus} from '@modules/administration/users/user.constant';
import {User} from '@modules/administration/users/interfaces/user.model';
import {NotificationService} from '@shared/services/notification.service';
import {UsersService} from '@modules/administration/users/services/users.service';
import {FilterUserRequest} from '@modules/administration/users/interfaces/user.request';
import {BaseResponse} from '@core/models/base-response.model';
import {MESSAGE_CODE} from '@shared/constants/message-code.constant';
import {RoleTypes} from '@modules/administration/administration.const';
import {debounceTime} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {NzModalService} from 'ng-zorro-antd/modal';
import {ViewUserComponent} from '@modules/administration/users/components/view-user/view-user.component';
import {CommonUtils} from '@shared/utils/utils';
import {EditUserComponent} from '@modules/administration/users/components/edit-user/edit-user.component';
import {Mode} from '@shared/enums/mode.enum';


@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
  readonly tableConfig = UserConstant.TABLE_CONFIG;
  readonly userRoleTypes = RoleTypes;
  readonly userStatus = UserConstant.USER_STATUS;
  readonly userStatusType = UserStatus;

  userList: User[] = [];
  filter: FilterUserRequest = new FilterUserRequest();

  private filter$ = new Subject<any>();

  constructor(
    private notiService: NotificationService,
    private userService: UsersService,
    private modalService: NzModalService,
  ) {
  }

  ngOnInit(): void {
    this.filter$
      .pipe(debounceTime(500))
      .subscribe((term) => {
        this.getList(true)
      });
  }

  getList(refresh: boolean = false, sort?: { sortBy: string, ascOrDesc: string }) {
    this.tableConfig.loading = true;
    if (refresh) {
      this.tableConfig.pageIndex = 1;
    }
    this.filter.pageSize = this.tableConfig.pageSize;
    this.filter.pageNumber = this.tableConfig.pageIndex;
    if (sort) {
      this.filter.sortBy = sort.sortBy;
      this.filter.ascOrDesc = sort.ascOrDesc;
    }
    this.userService.getList(this.filter).subscribe((res: BaseResponse<any, any>) => {
      if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
        this.userList = res.data.content;
        this.tableConfig.total = res.data.totalElements;
      }
      this.tableConfig.loading = false
    }, error => {
      this.tableConfig.loading = false
    }, () => this.tableConfig.loading = false);

  }

  filterChange($event) {
    this.filter$.next($event);
  }

  reload() {
    this.filter = new FilterUserRequest();
    this.getList(true);
  }

  view(user: User) {
    const modal = this.modalService.create({
      nzTitle:'Thông tin tài khoản',
      nzWidth: CommonUtils.getModalSize(window) ,
      nzContent: ViewUserComponent,
      nzComponentParams: {
        user: user,
      },
    });
  }

  edit(user: User) {
    const modal = this.modalService.create({
      nzTitle: user ? 'Chỉnh sửa tài khoản' : 'Thêm mới tài khoản',
      nzWidth: CommonUtils.getModalSize(window) ,
      nzContent: EditUserComponent,
      nzComponentParams: {
        data: user,
        mode: user ? Mode.EDIT : Mode.ADD
      },
      nzFooter: null
    });
    modal.afterClose.subscribe(result => {
      if (result) this.getList(result.refresh)
    })
  }

  verify(data: User) {
    this.userService.verify(data.id).subscribe((res: BaseResponse<any, any>) => {
      if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
        this.notiService.success("Kích hoạt thành công");
        data.status = res.data.status;
      }
    }, error => {
      this.notiService.error(BaseResponse.getMessage(error))
    });
  }

  lockOrUnlock(data: User) {
    this.userService.lockOrUnlock(data.id).subscribe((res: BaseResponse<any, any>) => {
      if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
        this.notiService.success("Kích hoạt thành công");
        data.status = res.data.status;
      }
    }, error => {
      this.notiService.error(BaseResponse.getMessage(error))
    });
  }

  delete(data: User) {
    this.userService.deleteUser(data.id).subscribe((res: BaseResponse<any, any>) => {
      if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
        this.notiService.success("Xóa thành công");
        this.getList(true);
      }
    }, error => {
      this.notiService.error(BaseResponse.getMessage(error))
    });
  }

  add() {
    this.edit(null);
  }

}
